var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./user-list.scp.html"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-74523c5c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./user-list.scp.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Products\\VCare\\Sourcecode\\branches\\PROD\\VCarePortal\\PharmacyPortal\\ClientApp\\components\\pages\\pharmacy\\user-list.scp.html"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] user-list.scp.html: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74523c5c", Component.options)
  } else {
    hotAPI.reload("data-v-74523c5c", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./ClientApp/components/pages/pharmacy/user-list.scp.html
// module id = 234
// module chunks = 0